// Features/Offer-Button/mod.ts
import { trackRequestOffer } from "Analytics";

class Button extends HTMLElement {
  html_popup;
  content;
  data;
  constructor() {
    super();
    this.html_popup = document.querySelector(`#Offer-Popup`);
    if (!this.html_popup)
      throw `#Offer-Popup element is missing`;
    this.addEventListener("click", () => this.open());
    const element = this.querySelector(`[ type = 'application/json' ]`);
    if (!element)
      throw `<script type = application/json> data element is missing in <sample-button>`;
    const { innerText } = element;
    this.data = JSON.parse(innerText);
    const overview = document.querySelector(`#Offer-Overview`);
    if (!overview) {
      this.remove();
      return;
    }
    this.content = overview.content;
  }
  async open() {
    const block = this.html_popup.block;
    block.appendChild(this.content);
    this.html_popup.popup.open();
    this.logRequest();
  }
  logRequest() {
    const { sku } = this.data;
    trackRequestOffer({ sku });
  }
}
customElements.define("offer-button", Button);
